import React from 'react';
import { render } from 'react-dom';
import AuthContainer from '../containers/Authorization';

$(() => {
  if ($('#signin').length) {
    initView();
  }
});

function initView() {
  render(
    <AuthContainer />,
    document.getElementById('signin')
  );
}

export default AuthContainer;
